import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import { Col, Row } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import FormInputField from '../../common/components/formFields/FormInputField';
import CommonButton from '../../common/components/CommonButton';
import { CommonButtonVariants } from '../../constants/CommonButtonVariants';
import { changeAccountPassword } from '../SettingsActions';
import { fetchMyProfileDetails } from '../myprofile/MyProfileActions';
import AlertContainer from '../../common/components/alert/AlertContainer';

const INITIAL_VALUES = {
  password: '',
  passwordRepeat: '',
};

function AccountPasswordForm() {
  const dispatch = useDispatch();
  const [localLoading, setLocalLoading] = useState(false);
  const organizationLocationId = useSelector(
    (state) => state.myProfile.get('myProfileDetails')?.organizationLocationDto?.id || '',
  );
  const position = useSelector(
    (state) => state.myProfile.get('myProfileDetails')?.position || '',
  );
  const version = useSelector(
    (state) => state.myProfile.get('myProfileDetails')?.version || '',
  );
  const myProfileDetails = useSelector((state) => state.myProfile.get('myProfileDetails'));
  const acceptNewsletter = true;

  useEffect(() => {
    if (!myProfileDetails || !myProfileDetails.version) {
      setLocalLoading(true);
      dispatch(fetchMyProfileDetails()).finally(() => setLocalLoading(false));
    }
  }, [dispatch, myProfileDetails, setLocalLoading]);

  const formValues = useMemo(
    () => ({
      ...INITIAL_VALUES,
      organizationLocationId,
      position,
      version,
      acceptNewsletter,
    }),
    [organizationLocationId, position, version, acceptNewsletter],
  );

  const handleSubmit = useCallback(
    async (values, { setSubmitting, resetForm }) => {
      try {
        setLocalLoading(true);
        await dispatch(changeAccountPassword(values));
        resetForm();
      } catch (error) {
        // Error is already handled in the action
      } finally {
        setSubmitting(false);
        setLocalLoading(false);
      }
    },
    [dispatch, setLocalLoading],
  );

  return (
    <Formik
      initialValues={formValues}
      onSubmit={handleSubmit}
      validateOnBlur={true}
      enableReinitialize
    >
      {({ handleSubmit: formHandleSubmit, isSubmitting }) => (
        <Form autoComplete="off" className="text-left">
          <Row className="justify-content-start mt-4">
            <div className="reset-password-alert">
              <AlertContainer position="custom" dismissable={false} />
            </div>
            <Col md="6" lg="4">
              <FormInputField
                name="password"
                label="New Password"
                type="password"
                autoComplete="new-password"
                labelVariant="bordered"
                showPasswordIcon
                passwordIconClassName="password-form-icon"
              />
            </Col>
            <Col md="6" lg="4">
              <FormInputField
                name="passwordRepeat"
                label="Confirm New Password"
                type="password"
                autoComplete="new-password"
                labelVariant="bordered"
                showPasswordIcon
                passwordIconClassName="password-form-icon"
              />
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md="6" lg="4">
              <CommonButton
                label="CHANGE PASSWORD"
                variant={CommonButtonVariants.OUTLINED_RED}
                disabled={localLoading || isSubmitting}
                handleClick={formHandleSubmit}
                type="submit"
                className="text-sm w-100"
              />
            </Col>
          </Row>
          <Field type="hidden" name="organizationLocationId" />
          <Field type="hidden" name="position" />
          <Field type="hidden" name="version" />
        </Form>
      )}
    </Formik>
  );
}

export default AccountPasswordForm;
